export const translations = {
    es: {
        // Títulos
        "preview.add": "Añadir",
        "preview.saved": "Guardado",
        "preview.saved.success": "Se ha guardado correctamente.",
        "preview.error": "Error en el servicio",
        "preview.error.admin": "Avisar al administrador",
        "preview.add.group": "Añadir nuevo grupo",
        zone: "Zona",

        // Pestañas
        "tab.data": "Grupo",
        "tab.containers": "Contenedores",
        "tab.locations": "Localizaciones",

        // Campos
        "field.name": "Nombre",
        "field.containers": "Contenedores",
        "field.long-lat": "Longitud / Latitud",
        "field.must": "Campos obligatorios",
        "field.must.island.name": "Por favor, ingrese un nombre para la isla",

        // Botones
        "button.save": "Guardar",
        "button.cancel": "Cancelar",
        "button.add": "Añadir",

        // Columnas de tabla
        "table.created": "Creada",
        "table.verified": "Verificada",
        "table.imported": "Importada",
        "table.finished": "Finalizada",
        "table.warnings": "Avisos",
        "table.error": "Error",
        "table.size": "Tamaño",
        "table.name": "Nombre",
        "table.description": "Descripción",
        "table.file": "Archivo",

        //alertas
        "alert.delete": "Borrar",
        "alert.delete.success": "Eliminación exitosa",
        "alert.delete.disp": "Solicitud de borrado de dispositivos enviada.",
        "alert.notify.admin": "Avisar al administrador",
        "alert.recovery.asset": "Error al recuperar los datos del contenedor",
        "alert.edit.disp.error": "Error al modificar el dispositivo",
        "alert.edit.error": "Error de edición",
        "alert.saved.disp": "Dispositivo guardado correctamente",
        "alert.saved": "Guardado",
        "alert.saved.disp.error": "Error al guardar un dispositivo",
        "alert.delete.groups": "Grupos eliminados correctamente",
        "alert.service.error": "Error del servicio",
        "alert.island.delete": "Islas eliminadas correctamente",
        "alert.island.export.error": "No se ha podido exportar el Excel de islas",

        //device status
        "devices_status.ok": "OK",
        "devices_status.al": "Alarma",
        "devices_status.nc": "Sin comunicación",
        "devices_status.nn": "Ninguno",
        "devices_status.nf": "No definido",
        "devices_status.wk": "Despertar",
        "devices_status.un": "Desinstalación",
        "devices_status.re": "Reemplazo",
    },
    en: {
        // Títulos
        "preview.add": "Add",
        "preview.saved": "Saved",
        "preview.saved.success": "Successfully saved.",
        "preview.error": "Service error",
        "preview.error.admin": "Contact administrator",
        "preview.add.group": "Add new group",
        zone: "Zone",

        // Pestañas
        "tab.data": "Group",
        "tab.containers": "Containers",
        "tab.locations": "Locations",

        // Campos
        "field.name": "Name",
        "field.containers": "Containers",
        "field.long-lat": "Longitude / Latitude",
        "filed.must": "Required fields",
        "filed.must.island.name": "Please enter a name for the island",

        // Botones
        "button.save": "Save",
        "button.cancel": "Cancel",
        "button.add": "Add",

        // Columnas de tabla
        "table.created": "Created",
        "table.verified": "Verified",
        "table.imported": "Imported",
        "table.finished": "Finished",
        "table.warnings": "Warnings",
        "table.error": "Error",
        "table.size": "Size",
        "table.name": "Name",
        "table.description": "Description",
        "table.file": "File",

        //alertas
        "alert.delete": "Delete",
        "alert.delete.success": "Delete success",
        "alert.delete.disp": "Delete request sent successfully",
        "alert.notify.admin": "Notify administrator",
        "alert.recovery.asset": "Error retrieving data from container",
        "alert.edit.disp.error": "Error modifying the device",
        "alert.edit.error": "Edit error",
        "alert.saved.disp": "Devices saved successfully",
        "alert.saved": "Saved",
        "alert.saved.disp.error": "Error saving a device",
        "alert.delete.groups": "Groups delete successfully",
        "alert.service.error": "Service error",
        "alert.island.delete": "Islands delete successfully",
        "alert.island.export.error": "The islands Excel could not be exported",

        //device status
        "devices_status.ok": "OK",
        "devices_status.al": "Alarm",
        "devices_status.nc": "Not communicate",
        "devices_status.nn": "None",
        "devices_status.nf": "Not defined",
        "devices_status.wk": "Wakeup",
        "devices_status.un": "Uninstall",
        "devices_status.re": "Replace",
    },
};
export default translations;
